import React from "react";
import styles from "./FormHIV.module.css";
import Calendar from "../../../components/calendar/Calendar";
import Utils from "../../../utils/Utils";
import Input from "../../../components/textbox/Input";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import OggettiUtili from "../../../utils/OggettiUtili.json";
import Autocomplete from "../../../components/autocomplete/Autocomplete";
import Ruoli from "../../../utils/Ruoli.json";
import RadioButton from "../../../components/radiobutton/RadioButton";
import Button from "../../../components/button/Button";
import Modale from "../../../components/modale/Modale";
import history from "../../../utils/History";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import toasterConfig from "../../../config/toasterConfig";
import SegnalazioniHIVServices from "../../../services/SegnalazioniHIVServices";
import $ from "jquery";
import Spinner from "../../../components/spinner/Spinner";
import { labelConfig } from "../../../config/labelConfig";
import CodiceUnivoco from "../components/CodiceUnivoco/CodiceUnivoco";

class FormHIV extends React.Component {
    state = {
        formModificato: false,
        showResetModal: false,
        modeResetModal: "pulisciCampi", // può essere solo 'pulisciCampi'|'reload'|'changePage'
        navigateAway: "",
        datiSegnalazione: {
            progressivoRegistro: "",
            dataCompilazione: "",
            dataSegnalazione: "",
            ulssSegnalazione: "",
            struttura: "",
        },
        datiAnagrafica: {
            id: "",
            eta: "",
            sesso: "",
            annoNascita: "",
            annoNascitaErrore: "",
            statoNascita: "",
            luogoNascita: "",
            cittadinanza: "",
            statoResidenza: "",
            luogoResidenza: "",
            ulssResidenza: "",
            provinciaResidenza: "",
        },
        esitoHIV: {
            esitoHIV: "",
            dataEsameHIV: "",
        },
        codicePaziente: {
            valoreCodice: "",
            errorMessage: "",
        },
        rischio: {
            comportamentoRischio: "",
            altroComportamentoRischio: "",
            annoInizioIniezioni: "",
            annoInizioIniezioniErrore: "",
            annoFineIniezioni: "",
            annoFineIniezioniErrore: "",
            naturaRapportiSessuali: "",
        },
        anamnesiPaziente: {
            dataUltimoTestNegativo: "",
            dataPrimaPositivita: "",
            presuntoLuogoAvvenutaInfezione: "",
            dataPresoInCaricoDalReparto: "",
            dataAnamnesi: "",
            motivazioneEsame: "",
            numeroAssolutoLinfocitiCD4: "",
        },
        datiGenerici: {
            COMPORTAMENTI_A_RISCHIO: OggettiUtili.COMPORTAMENTI_A_RISCHIO,
            RAPPORTI_SESSUALI: OggettiUtili.RAPPORTI_SESSUALI,
            COMUNI_ITALIA: Utils.distinctComuni(
                JSON.parse(localStorage.getItem("comuni"))
            ),
            COMUNI_RESIDENZA: JSON.parse(sessionStorage.getItem("comuni")),
            NAZIONI: JSON.parse(sessionStorage.getItem("nazioni")),
            PROVINCE: JSON.parse(sessionStorage.getItem("province")),
            LISTA_SESSI: OggettiUtili.LISTA_SESSI,
            LISTA_ESITO_HIV: OggettiUtili.LISTA_ESITO_HIV,
            STATO_NASCITA: OggettiUtili.STATO_NASCITA,
            STATO_RESIDENZA: OggettiUtili.STATO_RESIDENZA,
            LUOGO_AVVENUTA_INFEZIONE: OggettiUtili.LUOGO_AVVENUTA_INFEZIONE,
            MOTIVAZIONE_ESAME: OggettiUtili.MOTIVAZIONE_ESAME,
            AULSS_PER_CODICE: Utils.arrayToMap(
                JSON.parse(localStorage.getItem("aulss")),
                "codiceAziendaEsteso"
            ),
            ULSS: Utils.getArrayUlss(), //Contiene solo ULSS
            AULSS: Utils.mapToArray(OggettiUtili.ulssMapHIV), //Contiene ULSS e Aziende Ospedaliere
        },
        loading: false,
        testoModale: "",
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.onBlurCodiceUnivoco = this.onBlurCodiceUnivoco.bind(this);
        this.onBlurAnno = this.onBlurAnno.bind(this);
        this.validaCodiceUnivoco = this.validaCodiceUnivoco.bind(this);
        this.postSegnalazioneCompleta =
            this.postSegnalazioneCompleta.bind(this);
        this.putSegnalazioneCompleta = this.putSegnalazioneCompleta.bind(this);
        this.archiviaSegnalazione = this.archiviaSegnalazione.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.retrieveDataCompilazione =
            this.retrieveDataCompilazione.bind(this);
        this.navigateAway = this.navigateAway.bind(this);
        this.retrieveGroupFromKey = this.retrieveGroupFromKey.bind(this);
        this.getCalendarItemErrorMessage =
            this.getCalendarItemErrorMessage.bind(this);
        this.retrieveErroriDaComuneDiNascita =
            this.retrieveErroriDaComuneDiNascita.bind(this);
        this.retrieveErroriDaCalcoloEta =
            this.retrieveErroriDaCalcoloEta.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this);
        $(document).ready(function () {
            $("#dataCompilazione").datepicker("disable");
        });
        let progressivoRegistro = this.props.location.progressivoRegistro;
        if (progressivoRegistro) {
            this.getSegnalazione(
                Utils.removeEmptyValueFromObject(progressivoRegistro)
            );
            this.setNavLabel(1);
        } else {
            this.setNavLabel(0);
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.dataCompilazione = this.retrieveDataCompilazione();
            datiSegnalazione.struttura =
                SessioneUtente.getInstance().strutturaHIV;
            this.setState({ datiSegnalazione: datiSegnalazione });
        }
        if (SessioneUtente.getInstance().ulss) {
            let codiceUlss = SessioneUtente.getInstance().ulss;
            let datiSegnalazione = this.state.datiSegnalazione;
            datiSegnalazione.ulssSegnalazione = OggettiUtili.ulssMapHIV[codiceUlss]
                ? OggettiUtili.ulssMapHIV[codiceUlss]
                : "";
            this.setState({ datiSegnalazione: datiSegnalazione });
        }
    }

    componentDidUpdate() {
        if (history.location.hash === "#reload") {
            if (this.state.formModificato) {
                this.setState({
                    showResetModal: true,
                    modeResetModal: "reload",
                });
            } else {
                this.setState({ modeResetModal: "reload" });
                setTimeout(this.pulisciCampi, 100);
            }
            history.push("/formHIV");
        }
        if (
            history.location.search &&
            history.location.search.split("=")[0].substring(1) === "redirect" &&
            history.location.search.split("=")[1]
        ) {
            if (this.state.formModificato) {
                this.setState({
                    showResetModal: true,
                    modeResetModal: "changePage",
                    navigateAway: history.location.search.split("=")[1],
                });
                history.push("/formHIV");
            } else {
                history.push(history.location.search.split("=")[1]);
            }
        }
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione();
        ToasterSingleton.instance().pulisci();
        this.props.navLabel({ navLabel: {} });
    }

    retrieveDataCompilazione = () =>
        `${new Date().getDate() < 10 ? "0" : ""}${new Date().getDate()}/${
            new Date().getMonth() < 9 ? "0" : ""
        }${new Date().getMonth() + 1}/${new Date().getFullYear()}`;

    retrieveGroupFromKey = (key) =>
        Object.keys(this.state).find((group) =>
            Object.keys(this.state[group]).find((el) => el === key)
        );

    setNavLabel(n) {
        let navLabel = {
            label: labelConfig.formHIV[n],
        };
        this.props.navLabel({ navLabel: navLabel });
    }

    resetShowModale = () => {
        this.setState({ showResetModal: false });
        setTimeout(() => {
            this.setState({ modeResetModal: "pulisciCampi" });
        }, 200);
    };

    async getSegnalazione(progressivoRegistro) {
        this.setState({ loading: true });
        try {
            const segnalazione =
                await SegnalazioniHIVServices.getSegnalazioneHIV(
                    progressivoRegistro
                );
            const segnalazioneState = SegnalazioniHIVServices.mapData(
                "segnalazione",
                "frontend",
                segnalazione.data
            );
            const anagrafica = await SegnalazioniHIVServices.getAnagraficaHIV(
                segnalazione.data.idPaziente
            );
            const anagraficaState = SegnalazioniHIVServices.mapData(
                "anagrafica",
                "frontend",
                anagrafica.data
            );
            const newState = {
                ...segnalazioneState,
                ...anagraficaState,
                datiGenerici: { ...this.state.datiGenerici },
                loading: false,
            };
            this.setState(newState);
        } catch (e) {
            console.log("[ERROR]: getSegnalazioneHIV in errore", e);
            this.setState({ loading: false });
        }
    }

    async getSegnalazioniConCodiceUguale(codiceIndividualePaziente) {
        this.setState({ loading: true });
        let params = {
            codiceIndividualePaziente: encodeURIComponent(
                codiceIndividualePaziente
            ),
        };
        try {
            const segnalazione =
                await SegnalazioniHIVServices.getSegnalazioniHIV(params);
            this.setState({ loading: false });
            return segnalazione.data.content;
        } catch (e) {
            console.log("[ERROR]: getSegnalazioniHIV in errore", e);
            this.setState({ loading: false });
            return [];
        }
    }

    aggiungiToaster(text, textList) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList,
        });
    }

    resetFormPerReload = (newState, key, subKey) => {
        switch (subKey) {
            case "ulssSegnalazione":
                if (
                    SessioneUtente.getInstance().ruoliUtente !==
                        Ruoli.Operatore_Regionale.descrizione &&
                    SessioneUtente.getInstance().ulss
                ) {
                    let codiceUlss = SessioneUtente.getInstance().ulss;
                    newState[key][subKey] = OggettiUtili.ulssMapHIV[codiceUlss]
                        ? OggettiUtili.ulssMapHIV[codiceUlss]
                        : "";
                } else {
                    newState[key][subKey] = "";
                }
                break;
            case "struttura":
                newState[key][subKey] =
                    SessioneUtente.getInstance().strutturaHIV;
                break;
            case "dataCompilazione":
                newState[key][subKey] = this.retrieveDataCompilazione();
                break;
            default:
                newState[key][subKey] = "";
                break;
        }
        this.setNavLabel(0);
        return newState;
    };

    resetFormPerPuliziaCampi = (newState, key, subKey) => {
        if (
            (subKey !== "progressivoRegistro" &&
                subKey !== "dataCompilazione" &&
                subKey !== "ulssSegnalazione" &&
                subKey !== "struttura" &&
                subKey !== "id") ||
            (subKey === "ulssSegnalazione" &&
                !this.state.datiSegnalazione.progressivoRegistro &&
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Regionale.descrizione)
        )
            newState[key][subKey] = "";
        return newState;
    };

    pulisciCampi = () => {
        let newState = JSON.parse(JSON.stringify(this.state));
        newState.showResetModal = false;
        newState.formModificato = false;
        for (let key of Object.keys(newState)) {
            if (
                key === "datiGenerici" ||
                key === "modeResetModal" ||
                key === "navigateAway"
            )
                continue;
            for (let subKey of Object.keys(newState[key])) {
                // se siamo in inserimento e l'op è regionale azzera il campo ulssSegnalazione
                newState =
                    this.state.modeResetModal === "reload"
                        ? this.resetFormPerReload(newState, key, subKey)
                        : this.resetFormPerPuliziaCampi(newState, key, subKey);
            }
        }
        this.setState(newState);
        this.resetShowModale();
        setTimeout(Utils.scrollToTheTop, 200);
    };

    navigateAway = () => history.push(this.state.navigateAway);

    getErroreDaComparazioneDate = (listaDate, listaErrori) => {
        const listaDateObjects = [];

        // dalla lista crea una lista di obj con chiave e valore
        listaDate.forEach((el) => {
            for (let group of Object.keys(this.state)) {
                for (let key of Object.keys(this.state[group])) {
                    if (key === el && this.state[group][key] !== "")
                        listaDateObjects.push({
                            key: el,
                            value: new Date(
                                Utils.transformDateForBackend(
                                    this.state[group][key]
                                )
                            ).getTime(),
                        });
                }
            }
        });

        // scorri la lista dall'inizio verso il fondo
        for (let i = 0; i < listaDateObjects.length - 1; i++) {
            const objectDateOne = listaDateObjects[i];
            const objectDateTwo = listaDateObjects[i + 1];

            // se un valore è "" continue
            if (objectDateOne.value === "" || objectDateTwo.value === "")
                continue;

            // effettua la comparazione
            if (objectDateOne.value > objectDateTwo.value)
                listaErrori.push(
                    `${Utils.camelCaseToTitleCase(
                        objectDateOne.key
                    )} non può essere dopo ${Utils.camelCaseToTitleCase(
                        objectDateTwo.key
                    )}`
                );
        }
    };

    retrieveErroriDaCampiAnno = (listaErrori) => {
        // check errore nei campi anno presenti
        if (this.state.datiAnagrafica.annoNascitaErrore.length > 0)
            listaErrori.push("Anno nascita indicato sbagliato");
        if (this.state.rischio.annoInizioIniezioniErrore.length > 0)
            listaErrori.push("Anno inizio iniezioni indicato sbagliato");
        if (this.state.rischio.annoFineIniezioniErrore.length > 0)
            listaErrori.push("Anno fine iniezioni indicato sbagliato");

        // se anno nascita e codice paziente sono compilati senza errori fai comparazione ultime due cifre
        if (
            this.state.datiAnagrafica.annoNascita !== "" &&
            this.state.datiAnagrafica.annoNascitaErrore === "" &&
            this.state.codicePaziente.valoreCodice !== "" &&
            this.state.codicePaziente.errorMessage === "" &&
            Utils.isDateOnlyYearValid(this.state.codicePaziente.valoreCodice)
        ) {
            const anniIndicatiAnnoNascita =
                this.state.datiAnagrafica.annoNascita.toString().substring(2);
            const anniIndicatiCodiceUnivoco =
                this.state.codicePaziente.valoreCodice.substring(8, 10);
            if (anniIndicatiAnnoNascita !== anniIndicatiCodiceUnivoco) {
                listaErrori.push(
                    "Anno di nascita indicato non corrispondente con codice univoco"
                );
            }
        }

        // se anno nascita e anno inizio iniezioni sono presenti e senza errori fai comparazione
        if (
            this.state.rischio.annoInizioIniezioniErrore === "" &&
            this.state.rischio.annoInizioIniezioni !== "" &&
            this.state.datiAnagrafica.annoNascita !== "" &&
            this.state.datiAnagrafica.annoNascitaErrore === "" &&
            +this.state.rischio.annoInizioIniezioni <
                +this.state.datiAnagrafica.annoNascita
        ) {
            listaErrori.push(
                "Anno di inizio iniezioni non può essere antecedente ad anno di nascita"
            );
        }
        // gestione campi anni se rischio = iniezioni
        if (
            +this.state.rischio.comportamentoRischio ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                .USO_INIETTIVO_DI_DROGHE.id
        ) {
            // if (this.state.rischio.annoInizioIniezioni === "")
            //     listaErrori.push("Anno inizio iniezioni mancante");
            if (
                this.state.rischio.annoFineIniezioniErrore === "" &&
                this.state.rischio.annoInizioIniezioniErrore === "" &&
                +this.state.rischio.annoInizioIniezioni >
                    +this.state.rischio.annoFineIniezioni &&
                +this.state.rischio.annoFineIniezioni !== 0
            ) {
                listaErrori.push(
                    "Anno fine iniezioni non può essere prima di anno inizio iniezioni"
                );
            }
        }
    };

    isComuneValidForBirthDate = (comune, dataNascita) =>
        !Utils.checkDateIntervalMinore(comune.dataFineValidita, dataNascita) &&
        !Utils.checkDateIntervalMinore(dataNascita, comune.dataInizioValidita);

    retrieveErroriDaComuneDiNascita = (listaErrori) => {
        if (
            this.state.datiGenerici.COMUNI_ITALIA &&
            this.state.datiAnagrafica.statoNascita === "Nato in Italia" &&
            this.state.datiAnagrafica.luogoNascita &&
            Utils.isDateOnCodiceUnivocoValid(
                this.state.codicePaziente.valoreCodice
            )
        ) {
            let dataNascita = Utils.formatDateISO(
                this.retrieveDataNascitaFromCodiceUnivoco()
            );

            const annoNascitaIndicato = this.state.datiAnagrafica.annoNascita;
            const annoDataNascita = dataNascita.split("/")[2];

            // se esiste l'anno di nascita,
            // ed indica lo stesso anno ma in un secolo diverso
            // allora correggi dataNascita
            if (
                annoNascitaIndicato &&
                annoNascitaIndicato.toString().substring(2) ===
                    annoDataNascita.substring(2) &&
                annoNascitaIndicato !== annoDataNascita
            ) {
                dataNascita = dataNascita.split("/");
                dataNascita.pop();
                dataNascita.push(annoNascitaIndicato);
                dataNascita = dataNascita.join("/");
            }

            // se dataNascita esiste fai il controllo
            if (dataNascita !== "") {
                // retrieve lista comuni con lo stesso nome
                const listaComuniConUgualeNome = JSON.parse(
                    localStorage.getItem("comuni")
                ).filter(
                    (el) =>
                        el.descrizione ===
                        this.state.datiAnagrafica.luogoNascita.descrizione
                );

                // per ogni comune cerca se è valido per quella data di nascita
                const listaComuniValidiPerDataNascita =
                    listaComuniConUgualeNome.filter((el) =>
                        this.isComuneValidForBirthDate(el, dataNascita)
                    );

                // se nessun comune è valido per quella data aggiungi errore
                if (listaComuniValidiPerDataNascita.length === 0) {
                    listaErrori.push(
                        Utils.replaceContentString(
                            "Comune di Nascita non valido per la data <data>. Selezionare un Comune di Nascita valido.",
                            "<data>",
                            dataNascita
                        )
                    );
                } else {
                    this.setState((prevState) => ({
                        datiAnagrafica: {
                            ...prevState.datiAnagrafica,
                            luogoNascita: listaComuniValidiPerDataNascita[0],
                        },
                    }));
                }
            }
        }
    };

    compareBetweenAnnoNascitaEdEta = (annoEsame, etaIndicata, listaErrori) => {
        const annoNascita = +this.state.datiAnagrafica.annoNascita;
        const presuntaEta = annoEsame - annoNascita;
        if (presuntaEta === 0 && etaIndicata !== 0) {
            listaErrori.push(
                `Una persona che ha fatto l'esame nell'anno di nascita può avere solo zero anni`
            );
        } else if (
            presuntaEta !== etaIndicata &&
            presuntaEta - 1 !== etaIndicata
        )
            listaErrori.push(
                `Una persona nata nel ${annoNascita}, durante l'anno ${annoEsame} può avere solo ${
                    presuntaEta - 1
                } oppure ${presuntaEta} anni`
            );
    };

    retrieveErroriDaCalcoloEta = (listaErrori) => {
        const etaIndicata = +this.state.datiAnagrafica.eta;

        // la comparazione ha senso solo se sono indicate età e dataEsameHIV
        if (!etaIndicata || !this.isDataEsameHivValid()) return;

        const annoEsame = new Date(
            Utils.transformDateForBackend(this.state.esitoHIV.dataEsameHIV)
        ).getFullYear();

        // Caso 1: codice univoco con data completamente compilata
        if (
            Utils.isDateOnCodiceUnivocoValid(
                this.state.codicePaziente.valoreCodice
            )
        ) {
            const etaCalcolata = +this.calcolaEta();
            // anche se l'età indicata è superiore di 100 alla data originale allora va bene
            // altrimenti aggiungi l'errore
            if (etaIndicata !== etaCalcolata)
                listaErrori.push(
                    `Età indicata (${etaIndicata} anni) non coincidente con età calcolata dal Codice Individuale e dalla data Esame HIV (${etaCalcolata} anni)`
                );

            // Caso 2: codice univoco con data parzialmente compilata, solo anno
        } else if (
            Utils.isDateOnlyYearValid(this.state.codicePaziente.valoreCodice)
        ) {
            // se è compilato l'anno di nascita l'età può essere solo la differenza tra gli anni oppure la differenza - 1
            if (
                this.state.datiAnagrafica.annoNascita !== "" &&
                this.state.datiAnagrafica.annoNascitaErrore === ""
            ) {
                this.compareBetweenAnnoNascitaEdEta(
                    annoEsame,
                    etaIndicata,
                    listaErrori
                );
                // se non c'è definisci i possibili anni di nascita dal codice univoco
            } else {
                const anniIndicatiCodiceUnivoco =
                    this.state.codicePaziente.valoreCodice.substring(8, 10);
                const possibiliAnniNascita = [
                    +`${19}${anniIndicatiCodiceUnivoco}`,
                    +`${20}${anniIndicatiCodiceUnivoco}`,
                ];
                const currentYear = new Date().getFullYear();
                // se gli anni sono antecedenti al 1900 oppure nel futuro non si considerano
                if (possibiliAnniNascita[0] < 1900)
                    possibiliAnniNascita.reverse().pop();
                if (possibiliAnniNascita[1] > currentYear)
                    possibiliAnniNascita.pop();
                const presunteEta = possibiliAnniNascita.map(
                    (el) => annoEsame - el
                );
                const etaNonCoerente = presunteEta.every(
                    (el) => el !== etaIndicata && el - 1 !== etaIndicata
                );
                if (etaNonCoerente) {
                    listaErrori.push(
                        `Una persona nata nel ${possibiliAnniNascita.join(
                            " o nel "
                        )}, durante l'anno ${annoEsame} può avere solo ${presunteEta
                            .reverse()
                            .map((el) =>
                                el > 0 ? `${el - 1} oppure ${el}` : `${el}`
                            )
                            .join(" oppure ")} anni`
                    );
                }
            }
            // Caso 3: Codice Univoco senza anno valido ma campo anno nascita compilato
        } else if (
            this.state.datiAnagrafica.annoNascita &&
            !this.state.datiAnagrafica.annoNascitaErrore
        ) {
            this.compareBetweenAnnoNascitaEdEta(
                annoEsame,
                etaIndicata,
                listaErrori
            );
        }
    };

    getListaErroriFormField = () => {
        const listaErrori = [];

        const requiredFields = [
            "dataSegnalazione",
            "ulssSegnalazione",
            "valoreCodice",
            "dataEsameHIV",
            "esitoHIV",
        ];

        const dateFields = [
            "dataUltimoTestNegativo",
            "dataPrimaPositivita",
            "dataPresoInCaricoDalReparto",
            "dataAnamnesi",
            "dataEsameHIV",
            "dataSegnalazione",
            "dataCompilazione",
        ];

        // codice Individuale troppo corto o troppo lungo
        if (this.state.codicePaziente.valoreCodice.trim().length !== 11) {
            listaErrori.push(
                "Il codice individuale deve essere formato da 11 caratteri"
            );
            return listaErrori;
        }

        for (let key of Object.keys(this.state)) {
            if (key === "datiGenerici") continue;
            for (let subKey of Object.keys(this.state[key])) {
                // check fields required
                for (let requiredField of requiredFields) {
                    if (
                        requiredField === subKey &&
                        this.state[key][subKey] === ""
                    ) {
                        if (requiredField === "ulssSegnalazione") {
                            listaErrori.push(
                                "Azienda di segnalazione mancante"
                            );
                        } else {
                            listaErrori.push(
                                `${Utils.camelCaseToTitleCase(
                                    requiredField
                                )} mancante`
                            );
                        }
                    }
                }
                // check validità campi data
                for (let dateField of dateFields) {
                    if (
                        dateField === subKey &&
                        this.state[key][subKey] !== "" &&
                        this.getCalendarItemErrorMessage(key, subKey)
                    )
                        listaErrori.push(
                            `${Utils.camelCaseToTitleCase(dateField)} scorretta`
                        );
                }
            }
        }
        dateFields.splice(2, 3);

        this.getErroreDaComparazioneDate(dateFields, listaErrori);

        // codice Individuale errore
        if (this.state.codicePaziente.errorMessage !== "")
            listaErrori.push("Valore Codice Univoco sbagliato");

        this.retrieveErroriDaCampiAnno(listaErrori);

        this.retrieveErroriDaComuneDiNascita(listaErrori);

        this.retrieveErroriDaCalcoloEta(listaErrori);

        // correggi eventuale errori campi esame HIV
        listaErrori.forEach((err, index) => {
            if (err.includes("H I V")) {
                err = err.replace("H I V", "HIV");
                listaErrori[index] = err;
            }
            if (err.includes("Esito")) {
                err = err.replace("Esito", "Risultato Test");
                listaErrori[index] = err;
            }
        });

        return listaErrori;
    };

    submitSegnalazione = async () => {
        let stato = { ...this.state };
        const listaErrori = this.getListaErroriFormField();
        if (listaErrori.length > 0) {
            this.aggiungiToaster(listaErrori, true);
            return;
        }
        let segnalazioniEsistenti = await this.getSegnalazioniConCodiceUguale(
            stato.codicePaziente.valoreCodice
        );
        let struttura = "";
        let strutturaInserita = false;
        if (segnalazioniEsistenti.length > 0) {
            let testoModale = `<div><div class='mb-2'>Il codice individuale inserito è già presente nel sistema in quanto registrato dalle seguenti strutture:</div><ul class='mt-3'>`;
            segnalazioniEsistenti.forEach((segnalazione) => {
                if (segnalazione.idPaziente !== stato.datiAnagrafica.id) {
                    struttura = stato.datiGenerici.AULSS.find(
                        (el) => el.codice === segnalazione.codiceStruttura
                    ).descrizione;
                    if (
                        segnalazione.struttura &&
                        segnalazione.struttura !== ""
                    ) {
                        struttura = struttura.concat(
                            " - ",
                            segnalazione.struttura
                        );
                    }
                    if (!testoModale.includes(struttura)) {
                        testoModale = testoModale.concat(
                            `<li>`,
                            struttura,
                            `</li>`
                        );
                        strutturaInserita = true;
                    }
                }
            });
            testoModale =
                strutturaInserita === true
                    ? testoModale.concat(
                          `</ul>Si vuole procedere con il salvataggio delle informazioni inserite?</div>`
                      )
                    : "";
            this.setState({ testoModale: testoModale });
        }
        if (!strutturaInserita) {
            if (this.state.datiSegnalazione.progressivoRegistro) {
                await this.putSegnalazioneCompleta(stato.datiAnagrafica.id);
            } else {
                await this.postSegnalazioneCompleta();
            }
        } else {
            if (this.state.datiSegnalazione.progressivoRegistro) {
                $("#modalButton_modificaSegnalazioneCodicePaziente").trigger(
                    "click"
                );
            } else {
                $("#modalButton_inserisciSegnalazioneCodicePaziente").trigger(
                    "click"
                );
            }
        }
    };

    postSegnalazioneCompleta = async () => {
        this.setState({ loading: true });
        try {
            // mapping anagrafica
            const anagraficaObj = SegnalazioniHIVServices.mapData(
                "anagrafica",
                "backend",
                {
                    ...this.state.datiAnagrafica,
                    ...this.state.codicePaziente,
                }
            );
            // post anagrafica
            const paziente = await SegnalazioniHIVServices.postAnagraficaHIV(
                anagraficaObj
            );
            const inputData = JSON.parse(JSON.stringify(this.state));
            // mapping segnalazione
            const segnalazioneObj = SegnalazioniHIVServices.mapData(
                "segnalazione",
                "backend",
                { ...paziente.data, ...inputData }
            );
            // post segnalazione
            await SegnalazioniHIVServices.postSegnalazioneHIV(segnalazioneObj);
            this.setState({ loading: false });
            $("#modalButton_inserisciSegnalazioneOk").trigger("click");
        } catch (e) {
            this.setState({ loading: false });
            console.log("Errore in post segnalazione ", e);
        }
    };

    putSegnalazioneCompleta = async (id) => {
        this.setState({ loading: true });
        try {
            // mapping anagrafica
            const anagraficaObj = SegnalazioniHIVServices.mapData(
                "anagrafica",
                "backend",
                {
                    ...this.state.datiAnagrafica,
                    ...this.state.codicePaziente,
                }
            );
            // put anagrafica
            const paziente = await SegnalazioniHIVServices.putAnagraficaHIV(
                anagraficaObj,
                id
            );
            const inputData = JSON.parse(JSON.stringify(this.state));
            // mapping segnalazione
            const segnalazioneObj = SegnalazioniHIVServices.mapData(
                "segnalazione",
                "backend",
                { ...paziente.data, ...inputData }
            );
            // put segnalazione
            await SegnalazioniHIVServices.putSegnalazioneHIV(
                segnalazioneObj,
                this.state.datiSegnalazione.progressivoRegistro
            );
            this.setState({ loading: false });
            $("#modalButton_modificaSegnalazioneOk").trigger("click");
        } catch (e) {
            console.log("Errore in put segnalazione ", e);
            this.setState({ loading: false });
        }
    };

    archiviaSegnalazione = async () => {
        this.setState({ loading: true });
        try {
            await SegnalazioniHIVServices.archiviaSegnalazioneHIV(
                this.state.datiSegnalazione.progressivoRegistro
            );
            this.setState({ loading: false });
            $("#modalButton_eliminaSegnalazioneOk").trigger("click");
            this.setState({ loading: false });
        } catch (e) {
            console.log("Errore in archivia segnalazione ", e);
        }
    };

    getDateObject = (annoIndicato, mese, giorno) => {
        const annoCorrente = new Date().getFullYear().toString().substring(2);

        const annoComplessivo = +`${
            +annoIndicato > annoCorrente ? `19` : `20`
        }${annoIndicato}`;
        // il mese è in base 0 quindi va sottratto 1
        mese = +mese - 1;

        return new Date(annoComplessivo, mese, +giorno);
    };

    isDataEsameHivValid = () => {
        return (
            this.state.esitoHIV.dataEsameHIV &&
            Utils.isDateValid(
                this.state.esitoHIV.dataEsameHIV.split("/").reverse().join("/"),
                "/"
            ) &&
            !Utils.isDateInTheFuture(
                this.state.esitoHIV.dataEsameHIV.split("/").reverse().join("/")
            )
        );
    };

    calcolaEta = () => {
        // se le date su codice univoco o su esame non sono valide non procedo
        if (
            !Utils.isDateOnCodiceUnivocoValid(
                this.state.codicePaziente.valoreCodice
            ) ||
            !this.isDataEsameHivValid()
        )
            return "";

        // Converto le date in oggetti Date
        const dataNascitaObj = new Date(
            this.retrieveDataNascitaFromCodiceUnivoco()
        );
        const dataEsameHivObj = new Date(
            this.state.esitoHIV.dataEsameHIV.split("/").reverse().join("/")
        );

        // Ottengo l'anno di nascita e l'anno di calcolo
        let annoNascita = dataNascitaObj.getFullYear();
        const annoCalcolo = dataEsameHivObj.getFullYear();

        // se è presente il campo annoNascita, se annoNascita è senza errori
        // se annoNascita finisce con le stesse 2 cifre di annoNascitaParam ma non è uguale
        // allora considera annoNascitaField
        const annoNascitaString = annoNascita.toString();
        const annoNascitaField =
            this.state.datiAnagrafica.annoNascita.toString();
        const annoNascitaErrore = this.state.datiAnagrafica.annoNascitaErrore;

        if (
            annoNascitaField &&
            !annoNascitaErrore &&
            annoNascitaField.substring(2) === annoNascitaString.substring(2) &&
            annoNascitaField !== annoNascitaString
        )
            annoNascita = +annoNascitaField;

        // Calcolo l'età sottraendo l'anno di nascita dall'anno di calcolo
        let eta = annoCalcolo - annoNascita;

        if (eta < 0) return "";

        // Verifico se il compleanno è già avvenuto quest'anno
        // Se no, sottraggo 1 dall'età
        const meseNascita = dataNascitaObj.getMonth();
        const giornoNascita = dataNascitaObj.getDate();
        const meseCalcolo = dataEsameHivObj.getMonth();
        const giornoCalcolo = dataEsameHivObj.getDate();

        if (
            meseCalcolo < meseNascita ||
            (meseCalcolo === meseNascita && giornoCalcolo < giornoNascita)
        ) {
            eta--;
        }

        if (eta === -1) return 99;

        return eta;
    };

    riceviValore(field, event) {
        // definisci se è un input di tipo calendar o normale perché le chiavi ed i valori si ottengono diversamente
        const isFieldDate = !!field.currentTarget;
        const key = isFieldDate ? field.currentTarget.id : field;
        let value = isFieldDate ? field.target.value : event.target.value;

        this.setState({ formModificato: true });

        if (
            key === "ulssSegnalazione" &&
            this.state.datiAnagrafica.statoResidenza !==
                OggettiUtili.STATO_RESIDENZA.RESIDENTE_IN_ITALIA
        ) {
            this.setState((prevState) => ({
                datiAnagrafica: {
                    ...prevState.datiAnagrafica,
                    ulssResidenza: value,
                },
            }));
        }

        // i campi 'anno' ed numeroAssolutoLinfociti non possono iniziare per 0
        if (
            (key === "annoInizioIniezioni" ||
                key === "annoFineIniezioni" ||
                key === "annoNascita" ||
                key === "numeroAssolutoLinfocitiCD4") &&
            value.toString().startsWith("0")
        ) {
            value = value.toString().substring(1, value.length);
        }

        // se l'età contiene un char, oppure inizia per 0, oppure è più grande di 150 è invalida
        const isEtaInvalid =
            key === "eta" &&
            ((!/^[0-9]+$/.test(value) && value.trim().length > 0) ||
                (value.length > 1 && value[0].toString() === "0") ||
                +value > 150);

        // se i campi 'anno' o numeroAssolutoLinfociti contengono un char oppure hanno lunghezza > 4 sono invalidi
        const isAnnoOrContaLinfocitiInvalid =
            (key === "annoInizioIniezioni" ||
                key === "annoFineIniezioni" ||
                key === "annoNascita" ||
                key === "numeroAssolutoLinfocitiCD4") &&
            ((!/^[0-9]+$/.test(value) && value.trim().length > 0) ||
                value.length > 4);

        // se l'update proposto invalida il campo non applicarlo
        if (isEtaInvalid || isAnnoOrContaLinfocitiInvalid) return;

        // definisci a quale gruppo appartiene la chiave per il cambio di stato
        const group = this.retrieveGroupFromKey(key);

        // effettua l'aggiornamento di stato
        let groupToUpdate = this.state[group];
        groupToUpdate[key] = value;

        // se il field è statoNascita azzera anche il comune/stato
        if (field === "statoNascita") groupToUpdate.luogoNascita = "";

        // se il field è stato residenza azzera anche il comune/stato e la ULSS
        if (field === "statoResidenza") {
            groupToUpdate.luogoResidenza = "";
            groupToUpdate.provinciaResidenza = "";
            groupToUpdate.ulssResidenza = "";
            //se stato residenza è all'estero metti la ulss di residenza uguale a quella di segnalazione, altrimenti azzera
            if (value !== OggettiUtili.STATO_RESIDENZA.RESIDENTE_IN_ITALIA)
                groupToUpdate.ulssResidenza =
                    this.state.datiSegnalazione.ulssSegnalazione;
            if (value === OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA)
                groupToUpdate.luogoResidenza =
                    OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA;
        }

        if (field === "valoreCodice") {
            groupToUpdate.errorMessage =
                Utils.getMessaggioErroreCodiceUnivocoPazienteHIV(
                    this.state.codicePaziente.valoreCodice
                );
        }

        //se il field è luogo residenza aggiorna automaticamente alla ulss italiana corrispondente
        if (
            field === "luogoResidenza" &&
            this.state.datiAnagrafica.statoResidenza ===
                OggettiUtili.STATO_RESIDENZA.RESIDENTE_IN_ITALIA
        ) {
            groupToUpdate.ulssResidenza =
                this.state.datiGenerici.AULSS_PER_CODICE[value.codiceAulss];
            groupToUpdate.provinciaResidenza =
                this.state.datiGenerici.PROVINCE.find(
                    (el) => el.codice === value.codiceProvincia
                );
        }

        //se il field è comportamento rischio svuota i relativi campi
        if (field === "comportamentoRischio") {
            groupToUpdate.altroComportamentoRischio = "";
            groupToUpdate.annoInizioIniezioni = "";
            groupToUpdate.annoFineIniezioni = "";
            groupToUpdate.naturaRapportiSessuali = "";
        }

        if (
            field === "annoNascita" ||
            field === "annoInizioIniezioni" ||
            field === "annoFineIniezioni"
        ) {
            groupToUpdate = this.setErroreInputAnno(group, field, value);
        }

        this.setState({
            [group]: groupToUpdate,
        });

        // se il codice individuale ha data valida e non è valorizzato il campo età
        // ed il campo dataEsitoHIV è valido si calcola l'età
        if (
            key === "dataEsameHIV" &&
            Utils.isDateOnCodiceUnivocoValid(
                this.state.codicePaziente.valoreCodice
            ) &&
            this.state.datiAnagrafica.eta === "" &&
            Utils.isDateValid(value.split("/").reverse().join("/"), "/")
        ) {
            this.updateCampoEta();
        }
    }

    retrieveDataNascitaFromCodiceUnivoco = () => {
        const valoreCodiceAttuale = this.state.codicePaziente.valoreCodice;
        if (valoreCodiceAttuale.length < 10) return "";
        const giornoIndicato = `${valoreCodiceAttuale[4]}${valoreCodiceAttuale[5]}`;
        const meseIndicato = `${valoreCodiceAttuale[6]}${valoreCodiceAttuale[7]}`;
        const annoIndicato = `${valoreCodiceAttuale[8]}${valoreCodiceAttuale[9]}`;
        if (!Utils.isValidDate(annoIndicato, meseIndicato, giornoIndicato))
            return "";
        return this.getDateObject(annoIndicato, meseIndicato, giornoIndicato);
    };

    retrieveDataNascitaFromCodiceUnivocoOnlyYear = () => {
        const valoreCodiceAttuale = this.state.codicePaziente.valoreCodice;
        if (valoreCodiceAttuale.length < 10) return "";
        const giornoIndicato = "01";
        const meseIndicato = "01";
        const annoIndicato = `${valoreCodiceAttuale[8]}${valoreCodiceAttuale[9]}`;
        if (!Utils.isValidDate(annoIndicato, meseIndicato, giornoIndicato))
            return "";
        return this.getDateObject(annoIndicato, meseIndicato, giornoIndicato);
    };

    updateCampoEta = () => {
        let eta = this.calcolaEta();
        if (eta !== "")
            this.setState((prevState) => ({
                datiAnagrafica: {
                    ...prevState.datiAnagrafica,
                    eta: eta,
                },
            }));
    };

    onBlurAnno = (key) => {
        // retrieve group
        const group = this.retrieveGroupFromKey(key);
        // retrieve valoreErrore - if errore return
        const keyError = `${key}Errore`;
        if (this.state[group][keyError] !== "") return;
        // retrieve valore
        const value = this.state[group][key].toString();

        // if valore incompleto c'è errore
        if (value.length > 0 && value.length < 4) {
            const groupToUpdate = JSON.parse(JSON.stringify(this.state[group]));
            groupToUpdate[keyError] = `${Utils.camelCaseToTitleCase(
                key
            )} incompleto`;
            groupToUpdate[key] = value + " ";
            this.setState({
                [group]: groupToUpdate,
            });
            setTimeout(() => {
                groupToUpdate[key] = +value;
                this.setState(
                    this.setState({
                        [group]: groupToUpdate,
                    })
                );
            }, 200);
        }
    };

    onBlurCodiceUnivoco = () => {
        // converti il codice univoco in uppercase
        this.setState((prevState) => ({
            codicePaziente: {
                valoreCodice:
                    prevState.codicePaziente.valoreCodice.toUpperCase(),
                errorMessage: prevState.codicePaziente.errorMessage,
            },
        }));

        // se c'è già un errore evidenziato non continuare
        if (this.state.codicePaziente.errorMessage) return;

        const valoreCodiceAttuale = this.state.codicePaziente.valoreCodice;

        // check lunghezza del codice, se non è 11 chars indica l'errore
        // è necessario cambiare il valore di valoreCodice per il rendering
        if (
            valoreCodiceAttuale.length !== 11 &&
            valoreCodiceAttuale.length !== 0
        ) {
            const appendingMessage =
                valoreCodiceAttuale.length < 11
                    ? `, ne manca${
                          valoreCodiceAttuale.length === 10 ? "" : "no"
                      } ${11 - valoreCodiceAttuale.length}`
                    : ` ce ne sono ${valoreCodiceAttuale.length}`;

            this.setState({
                codicePaziente: {
                    valoreCodice: valoreCodiceAttuale + " ",
                    errorMessage: `Il codice deve essere di 11 caratteri${appendingMessage}`,
                },
            });
            // timeout che ripristina il valore originale di valoreCodice
            setTimeout(() => {
                this.setState((prevState) => ({
                    codicePaziente: {
                        ...prevState.codicePaziente,
                        valoreCodice: valoreCodiceAttuale,
                    },
                }));
            }, 200);
        }

        // se in merito al Codice Univoco la lunghezza non è giusta non continuare
        if (
            valoreCodiceAttuale.length !== 11 ||
            this.state.codicePaziente.errorMessage !== ""
        )
            return;

        // inizializza i nuovi dati anagrafica
        const datiAnagraficaUpdated = JSON.parse(
            JSON.stringify(this.state.datiAnagrafica)
        );

        // se il valore della data sul codice è valido ricalcola annoNascita
        if (Utils.isDateOnlyYearValid(this.state.codicePaziente.valoreCodice)) {
            const dataNascita =
                this.retrieveDataNascitaFromCodiceUnivocoOnlyYear();

            const annoPresuntoNascita =
                dataNascita === "" ? "" : dataNascita.getFullYear();

            const annoNascita =
                dataNascita === ""
                    ? ""
                    : this.retrieveDataNascitaFromCodiceUnivoco().getTime() >
                      Date.now()
                    ? annoPresuntoNascita - 100
                    : annoPresuntoNascita;

            // se anno nascita è già valorizzato con un valore compatibile con quello scoperto non aggiornare
            const annoNascitaString = annoNascita.toString();
            const annoNascitaField =
                this.state.datiAnagrafica.annoNascita.toString();
            const annoNascitaErrore =
                this.state.datiAnagrafica.annoNascitaErrore;

            if (
                !annoNascitaField ||
                annoNascitaErrore ||
                annoNascitaField.substring(2) !== annoNascitaString.substring(2)
            ) {
                datiAnagraficaUpdated.annoNascita = annoNascita;
                datiAnagraficaUpdated.annoNascitaErrore = "";
            }
        }
        // se il valore della data sul codice è valido ricalcola sesso
        if (
            Utils.isSexOnCondiceUnivocoValid(
                this.state.codicePaziente.valoreCodice
            )
        ) {
            datiAnagraficaUpdated.sesso =
                valoreCodiceAttuale[10] === "M" ||
                valoreCodiceAttuale[10] === "m"
                    ? "Maschio"
                    : "Femmina";
        } else {
            datiAnagraficaUpdated.sesso = "";
        }

        this.setState({
            datiAnagrafica: datiAnagraficaUpdated,
            rischio: {
                comportamentoRischio: "",
                altroComportamentoRischio: "",
                annoInizioIniezioni: "",
                annoInizioIniezioniErrore: "",
                annoFineIniezioni: "",
                annoFineIniezioniErrore: "",
                naturaRapportiSessuali: "",
            },
        });

        if (this.state.datiAnagrafica.eta === "")
            setTimeout(this.updateCampoEta, 200);
    };

    validaCodiceUnivoco = () =>
        this.state.codicePaziente.errorMessage.length === 0 ? 2 : 1;

    setErroreInputAnno = (group, field, value) => {
        const input = value.toString();
        let error = "";
        if (input[0] !== undefined && input[0] !== "1" && input[0] !== "2")
            error = "Il primo numero può essere solo '1' o '2'";
        if (
            !error &&
            input[1] !== undefined &&
            input[0] === "1" &&
            input[1] !== "9"
        )
            error = "Non puoi mettere date anteriori al 1900";
        if (
            !error &&
            input[1] !== undefined &&
            input[0] === "2" &&
            input[1] !== "0"
        )
            error = "Non puoi mettere date in un secolo futuro";
        // getCurrentYear
        const currentYear = new Date().getFullYear();
        // If annoIndicato > currentYear errore
        if (
            !error &&
            input[2] !== undefined &&
            input[1] === "0" &&
            +`20${input[2]}0` > currentYear
        )
            error = "Non puoi mettere date in un decennio futuro";
        if (
            !error &&
            input[3] !== undefined &&
            input[1] === "0" &&
            +`20${input[2]}${input[3]}` > currentYear
        )
            error = "Non puoi mettere date in un anno futuro";

        const keyToUpdate = `${field}Errore`;

        const groupToUpdate = JSON.parse(JSON.stringify(this.state[group]));
        groupToUpdate[keyToUpdate] = error;

        return groupToUpdate;
    };

    validaAnno = (input) => (input.length === 0 ? 2 : 1);

    tornaAllaHome = () => history.push({ pathname: `/homeHIV` });

    isRapportoSessuale = (input) =>
        input ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO.PROSTITUZIONE.id ||
        input ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                .RAPPORTI_ETEROSESSUALI_CON_SIEROPOSITIVI.id ||
        input ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                .RAPPORTI_ETEROSESSUALI_SENZA_SIEROPOSITIVI.id ||
        input ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                .RAPPORTI_OMOSESSUALI_CON_SIEROPOSITIVI.id ||
        input ===
            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                .RAPPORTI_OMOSESSUALI_SENZA_SIEROPOSITIVI.id;

    getCalendarItemErrorMessage = (group, key) => {
        if (this.state[group][key] === "" || this.state[group][key] === null)
            return "";
        const date = Utils.transformDateForBackend(this.state[group][key]);
        if (Utils.isDateInValid(date, "-")) return "Data non valida";
        if (new Date(date).getTime() > Date.now())
            return "Data nel futuro non valida";
        return "";
    };

    isCalendarItemError = (group, key) =>
        this.getCalendarItemErrorMessage(group, key).length > 0;

    render() {
        const getFieldSet = (
            labelKey,
            labelMandatory,
            inputValue,
            disabled,
            subLabel
        ) => {
            return (
                <div className={`row ${styles.fieldSet}`}>
                    <div className="col-lg-10 mt-1">
                        <div className="row">
                            {getLabel(
                                labelKey,
                                labelMandatory,
                                disabled,
                                subLabel
                            )}
                            <div className="col-lg-8">{inputValue}</div>
                        </div>
                    </div>
                </div>
            );
        };

        const getLabel = (label, mandatory, disabled, subLabel) => {
            return (
                <div className="col-lg-4">
                    <p
                        className={`${styles.label} ${
                            disabled ? styles.disabled : ""
                        }`}
                    >
                        {label}
                        {mandatory && (
                            <span className={styles.mandatory}>*</span>
                        )}
                        {subLabel && <br />}
                        {subLabel && (
                            <span className={styles.subLabel}>{subLabel}</span>
                        )}
                    </p>
                </div>
            );
        };

        const getCalendarItem = (group, key) => {
            return (
                <Calendar
                    id={key}
                    value={this.state[group][key]}
                    field={key}
                    onChange={this.riceviValore}
                    errorMessage={this.getCalendarItemErrorMessage(group, key)}
                    error={this.isCalendarItemError(group, key)}
                />
            );
        };

        const dataCompilazione = (
            <Calendar
                id={"dataCompilazione"}
                value={Utils.transformTimeStampForFrontend(
                    this.state.datiSegnalazione.dataCompilazione
                )}
                field={"dataCompilazione"}
                disabled={true}
            />
        );

        const progressivoRegistro = (
            <Input
                id={"progressivoRegistro"}
                value={this.state.datiSegnalazione.progressivoRegistro}
                disabled
            />
        );

        const struttura = (
            <Input
                id={"struttura"}
                value={this.state.datiSegnalazione.struttura}
                disabled
            />
        );

        const getUlssSegnalazione = () => {
            return getSelect(
                "datiSegnalazione",
                "ulssSegnalazione",
                SessioneUtente.getInstance().ruoliUtente !==
                    Ruoli.Operatore_Regionale.descrizione ||
                    isModificaSegnalazione
                    ? this.state.datiGenerici.AULSS
                    : this.state.datiGenerici.ULSS,
                SessioneUtente.getInstance().ruoliUtente !==
                    Ruoli.Operatore_Regionale.descrizione ||
                    isModificaSegnalazione,
                "Azienda di segnalazione"
            );
        };

        const getUlssResidenza = () => {
            return getSelect(
                "datiAnagrafica",
                "ulssResidenza",
                this.state.datiGenerici.AULSS_PER_CODICE,
                this.state.datiAnagrafica.statoResidenza === "",
                "ULSS di residenza"
            );
        };

        const getSelect = (
            group,
            field,
            listOptions,
            disabled,
            placeholder
        ) => {
            return (
                <Autocomplete
                    showSuggestions={false}
                    id={field}
                    value={this.state[group][field]}
                    keyField={"codice"}
                    descriptionField={"descrizione"}
                    suggestionField={"descrizione"}
                    placeholder={placeholder}
                    onChange={this.riceviValore}
                    field={field}
                    suggestions={listOptions}
                    disabled={disabled}
                />
            );
        };

        const getInput = (
            group,
            field,
            errorMessage,
            placeholder,
            onValidate,
            onBlur,
            disabled
        ) => {
            return group === "codicePaziente" && field === "valoreCodice" ? (
                <CodiceUnivoco
                    onBlur={onBlur}
                    id={field}
                    placeholder={placeholder}
                    onChange={this.riceviValore}
                    field={field}
                    value={this.state[group][field]}
                    errorMessage={errorMessage}
                    onValidate={onValidate}
                    disabled={disabled}
                />
            ) : (
                <Input
                    onBlur={onBlur}
                    id={field}
                    placeholder={placeholder}
                    onChange={this.riceviValore}
                    field={field}
                    value={this.state[group][field]}
                    errorMessage={errorMessage}
                    onValidate={onValidate}
                    disabled={disabled}
                />
            );
        };

        /* Per evitare errori visto il funzionamento di riceviValore è necessario che 
        gli items delle diverse liste invocate nel componente abbiano tutti valori diversi */
        const getListOptions = (
            list,
            group,
            name,
            row,
            disabled,
            sottolineaSelected
        ) => {
            const listRadioButtons = [];
            Object.keys(list).forEach((el) => {
                let unabled = disabled;
                if (
                    name === "comportamentoRischio" &&
                    list[el].id !== 1004 &&
                    list[el].id !== 1005
                )
                    unabled = false;
                listRadioButtons.push(
                    <RadioButton
                        key={list[el].id ? list[el].id : list[el]}
                        id={list[el].id ? list[el].id : list[el]}
                        name={name}
                        label={
                            list[el].descrizione
                                ? list[el].descrizione
                                : list[el]
                        }
                        onClick={this.riceviValore}
                        smallLabel={true}
                        value={list[el].id ? list[el].id : list[el]}
                        disabled={unabled}
                        sottolineaSelected={sottolineaSelected}
                        newRadio={true}
                        checked={
                            list[el].id
                                ? +this.state[group][name] === list[el].id
                                : this.state[group][name] === list[el]
                        }
                    />
                );
            });
            return (
                <div className={row ? "row" : styles.list}>
                    {listRadioButtons}
                </div>
            );
        };

        const getLuogoDiResidenza = () => {
            return this.state.datiAnagrafica.statoResidenza ===
                OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA
                ? getInput(
                      "datiAnagrafica",
                      "luogoResidenza",
                      null,
                      null,
                      null,
                      null,
                      true
                  )
                : getSelect(
                      "datiAnagrafica",
                      "luogoResidenza",
                      this.state.datiAnagrafica.statoResidenza ===
                          OggettiUtili.STATO_RESIDENZA.RESIDENTE_ESTERO
                          ? this.state.datiGenerici.NAZIONI.filter(
                                (el) => el.descrizione !== "Italia"
                            )
                          : this.state.datiGenerici.COMUNI_RESIDENZA,
                      this.state.datiAnagrafica.statoResidenza === "",
                      this.state.datiAnagrafica.statoResidenza ===
                          OggettiUtili.STATO_RESIDENZA.RESIDENTE_ESTERO
                          ? "Stato di residenza"
                          : "Comune di residenza"
                  );
        };

        const isModificaSegnalazione =
            this.state.datiSegnalazione.progressivoRegistro !== "";

        const getResetModalText = (type) => {
            if (this.state.modeResetModal === "reload") {
                switch (type) {
                    case "modalText":
                        return "Ricaricando il form i dati inseriti verranno persi, confermi?";
                    case "buttonText":
                        return "Ricarica";
                    case "title":
                        return "Ricarica Form";
                }
            } else if (this.state.modeResetModal === "changePage") {
                switch (type) {
                    case "modalText":
                        return "Cambiando pagina eventuali dati inseriti andranno persi, confermi?";
                    case "buttonText":
                        return "Procedi";
                    case "title":
                        return "Cambia Pagina";
                }
            } else if (this.state.modeResetModal === "pulisciCampi") {
                switch (type) {
                    case "modalText":
                        return "Hai selezionato l'azzeramento dei dati inseriti, confermi?";
                    case "buttonText":
                        return "Pulisci";
                    case "title":
                        return "Pulisci Campi";
                }
            }
        };

        return (
            <div className={styles.hivForm}>
                {this.state.loading ? (
                    <div>
                        <Spinner />
                    </div>
                ) : (
                    <></>
                )}
                <h6 className={styles.title}>Dati Segnalazione</h6>
                <hr></hr>
                <div className={`container ${styles.container}`}>
                    {getFieldSet(
                        "Azienda di segnalazione",
                        true,
                        getUlssSegnalazione()
                    )}
                    {getFieldSet("Struttura", true, struttura, true)}
                    {this.state.datiSegnalazione.progressivoRegistro !== "" &&
                        getFieldSet(
                            "Progressivo di registro",
                            true,
                            progressivoRegistro,
                            true
                        )}
                    {getFieldSet(
                        "Data Compilazione",
                        true,
                        dataCompilazione,
                        true
                    )}
                    {getFieldSet(
                        "Data Segnalazione",
                        true,
                        getCalendarItem("datiSegnalazione", "dataSegnalazione")
                    )}
                </div>
                <h6 className={styles.title}>Dati Anagrafici</h6>
                <hr></hr>
                <div className={`container ${styles.container}`}>
                    {getFieldSet(
                        "Codice Individuale",
                        true,
                        getInput(
                            "codicePaziente",
                            "valoreCodice",
                            this.state.codicePaziente.errorMessage,
                            "Codice Individuale",
                            this.validaCodiceUnivoco(),
                            this.onBlurCodiceUnivoco
                        )
                    )}
                    <p className={styles.spiegazione}>
                        Specifiche: inserire prima e terza lettera del cognome,
                        prima e terza lettera del nome, le cifre della data di
                        nascita con le ultime due cifre dell'anno (gg/mm/aa) e
                        la lettera del sesso. Vanno ignorati gli spazi e
                        apostrofi. Qualora uno o più elementi mancassero vanno
                        sostituiti con il carattere cancelletto #. Il codice
                        deve essere lungo 11 caratteri.
                    </p>
                    {getFieldSet(
                        "Anno di Nascita",
                        false,
                        getInput(
                            "datiAnagrafica",
                            "annoNascita",
                            this.state.datiAnagrafica.annoNascitaErrore,
                            "Anno di Nascita",
                            this.validaAnno(
                                this.state.datiAnagrafica.annoNascitaErrore
                            ),
                            () => this.onBlurAnno("annoNascita")
                        )
                    )}
                    {getFieldSet(
                        "Età",
                        false,
                        getInput(
                            "datiAnagrafica",
                            "eta",
                            "Età non valida",
                            "Età"
                        )
                    )}
                    {getFieldSet(
                        "Sesso alla nascita",
                        false,
                        getListOptions(
                            this.state.datiGenerici.LISTA_SESSI,
                            "datiAnagrafica",
                            "sesso",
                            true,
                            true,
                            true
                        )
                    )}
                    {getFieldSet(
                        "Luogo di Nascita",
                        false,
                        getListOptions(
                            this.state.datiGenerici.STATO_NASCITA,
                            "datiAnagrafica",
                            "statoNascita",
                            true
                        )
                    )}
                    {getFieldSet(
                        `${
                            this.state.datiAnagrafica.statoNascita ===
                            "Nato all'Estero"
                                ? "Stato"
                                : "Comune"
                        } di Nascita`,
                        false,
                        getSelect(
                            "datiAnagrafica",
                            "luogoNascita",
                            this.state.datiAnagrafica.statoNascita ===
                                "Nato all'Estero"
                                ? this.state.datiGenerici.NAZIONI.filter(
                                      (el) => el.descrizione !== "Italia"
                                  )
                                : this.state.datiGenerici.COMUNI_ITALIA,
                            this.state.datiAnagrafica.statoNascita === "",
                            this.state.datiAnagrafica.statoNascita ===
                                "Nato all'Estero"
                                ? "Stato di nascita"
                                : "Comune di nascita"
                        ),
                        this.state.datiAnagrafica.luogoNascita === ""
                    )}
                    {getFieldSet(
                        "Luogo di Residenza",
                        false,
                        getListOptions(
                            this.state.datiGenerici.STATO_RESIDENZA,
                            "datiAnagrafica",
                            "statoResidenza",
                            true
                        )
                    )}
                    {getFieldSet(
                        `${
                            this.state.datiAnagrafica.statoResidenza ===
                            OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA
                                ? "Luogo"
                                : this.state.datiAnagrafica.statoResidenza ===
                                  OggettiUtili.STATO_RESIDENZA.RESIDENTE_ESTERO
                                ? "Stato"
                                : "Comune"
                        } di Residenza`,
                        false,
                        getLuogoDiResidenza(),
                        this.state.datiAnagrafica.statoResidenza === ""
                    )}
                    {this.state.datiAnagrafica.statoResidenza ===
                        OggettiUtili.STATO_RESIDENZA.RESIDENTE_IN_ITALIA &&
                        getFieldSet(
                            "Provincia di Residenza",
                            false,
                            <Input
                                id={"provincia"}
                                placeholder={"Provincia di Residenza"}
                                field={"provincia"}
                                value={
                                    this.state.datiAnagrafica
                                        .provinciaResidenza &&
                                    this.state.datiAnagrafica.provinciaResidenza
                                        .descrizione
                                        ? this.state.datiAnagrafica
                                              .provinciaResidenza.descrizione
                                        : ""
                                }
                                disabled={true}
                            />
                        )}
                    {getFieldSet("ULSS Residenza", false, getUlssResidenza())}
                    {getFieldSet(
                        "Cittadinanza",
                        false,
                        getSelect(
                            "datiAnagrafica",
                            "cittadinanza",
                            this.state.datiGenerici.NAZIONI,
                            false,
                            "Cittadinanza"
                        )
                    )}
                    {getFieldSet(
                        "Data Presa in Carico dal Reparto",
                        false,
                        getCalendarItem(
                            "anamnesiPaziente",
                            "dataPresoInCaricoDalReparto"
                        )
                    )}
                </div>
                <h6>
                    Test HIV{" "}
                    <span className={styles.subtitolo}>(Diagnosi finale)</span>{" "}
                </h6>
                <hr className={styles.HIVHR} />
                <div className={`${styles.containerHIV}`}>
                    <div className={`container`}>
                        {getFieldSet(
                            "Data esame",
                            true,
                            getCalendarItem("esitoHIV", "dataEsameHIV")
                        )}
                        {getFieldSet(
                            "Risultato",
                            true,
                            getListOptions(
                                this.state.datiGenerici.LISTA_ESITO_HIV,
                                "esitoHIV",
                                "esitoHIV",
                                true
                            )
                        )}
                    </div>
                </div>
                <h6 className={styles.title}>
                    Comportamento a Rischio{" "}
                    <span className={styles.subtitolo}>
                        (Selezionare una sola scelta)
                    </span>{" "}
                </h6>
                {this.state.datiAnagrafica.sesso === "Femmina" ? (
                    <div className={styles.comportamentoRischio}>
                        <hr className={styles.comportamentoRischioHR} />
                        <p style={{ marginLeft: "10px" }}>
                            <b>Attenzione! </b>
                            Il sistema dell'Istituto Superiore di Sanità non
                            accetta la modalità "Rapporti omosessuali" per il
                            genere femmina (F), pertanto per questa casistica
                            inserire "Altro (da specificare)" e indicare nella
                            casella di testo "Rapporti omosessuali"
                        </p>
                    </div>
                ) : (
                    <hr />
                )}
                <div className="container">
                    {getFieldSet(
                        "",
                        false,
                        getListOptions(
                            this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO,
                            "rischio",
                            "comportamentoRischio",
                            false,
                            this.state.datiAnagrafica.sesso === "Femmina"
                        )
                    )}
                    {this.isRapportoSessuale(
                        +this.state.rischio.comportamentoRischio
                    ) &&
                        getFieldSet(
                            "Specificare",
                            false,
                            getListOptions(
                                this.state.datiGenerici.RAPPORTI_SESSUALI,
                                "rischio",
                                "naturaRapportiSessuali"
                            )
                        )}
                    {+this.state.rischio.comportamentoRischio ===
                        this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO.ALTRO
                            .id &&
                        getFieldSet(
                            "Specificare",
                            false,
                            getInput(
                                "rischio",
                                "altroComportamentoRischio",
                                undefined,
                                "Altro comportamento a rischio"
                            )
                        )}
                    {+this.state.rischio.comportamentoRischio ===
                        this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                            .USO_INIETTIVO_DI_DROGHE.id &&
                        getFieldSet(
                            "Anno di Inizio Iniezioni",
                            false,
                            getInput(
                                "rischio",
                                "annoInizioIniezioni",
                                this.state.rischio.annoInizioIniezioniErrore,
                                "Anno Inizio iniezioni",
                                this.validaAnno(
                                    this.state.rischio.annoInizioIniezioniErrore
                                ),
                                () => this.onBlurAnno("annoInizioIniezioni")
                            )
                        )}
                    {+this.state.rischio.comportamentoRischio ===
                        this.state.datiGenerici.COMPORTAMENTI_A_RISCHIO
                            .USO_INIETTIVO_DI_DROGHE.id &&
                        getFieldSet(
                            "Anno di Fine Iniezioni",
                            false,
                            getInput(
                                "rischio",
                                "annoFineIniezioni",
                                this.state.rischio.annoFineIniezioniErrore,
                                "Anno Fine iniezioni",
                                this.validaAnno(
                                    this.state.rischio.annoFineIniezioniErrore
                                ),
                                () => this.onBlurAnno("annoFineIniezioni")
                            )
                        )}
                </div>
                <h6 className={styles.title}>Anamnesi Paziente</h6>
                <hr></hr>
                <div className={`container ${styles.container}`}>
                    {getFieldSet(
                        "Data Ultimo Test Negativo",
                        false,
                        getCalendarItem(
                            "anamnesiPaziente",
                            "dataUltimoTestNegativo"
                        )
                    )}
                    {getFieldSet(
                        "Data Prima Positività Rilevata",
                        false,
                        getCalendarItem(
                            "anamnesiPaziente",
                            "dataPrimaPositivita"
                        )
                    )}
                    {getFieldSet(
                        "Presunto Luogo Avvenuta Infezione",
                        false,
                        getListOptions(
                            this.state.datiGenerici.LUOGO_AVVENUTA_INFEZIONE,
                            "anamnesiPaziente",
                            "presuntoLuogoAvvenutaInfezione"
                        )
                    )}
                    {getFieldSet(
                        "Linfociti CD4⁺",
                        false,
                        getInput(
                            "anamnesiPaziente",
                            "numeroAssolutoLinfocitiCD4",
                            undefined,
                            "Numero assoluto Linfociti CD4⁺"
                        ),
                        false,
                        "Numero Assoluto Cellule per mm³"
                    )}
                    {getFieldSet(
                        "Data conta linfociti",
                        false,
                        getCalendarItem("anamnesiPaziente", "dataAnamnesi")
                    )}
                    {getFieldSet(
                        "Motivazione Esame",
                        false,
                        getListOptions(
                            this.state.datiGenerici.MOTIVAZIONE_ESAME,
                            "anamnesiPaziente",
                            "motivazioneEsame"
                        )
                    )}
                </div>
                <div className={styles.mandatory}>* Campo obbligatorio</div>
                <div className={styles.buttonDiv}>
                    {isModificaSegnalazione ? (
                        <div>
                            <Modale
                                classes={`btnOutlineViola ${styles.buttonElimina}`}
                                id={"eliminaSegnalazione"}
                                typeModal={"modalViola"}
                                modalText={
                                    "Stai per eliminare la scheda, sei sicuro?"
                                }
                                text={"Elimina segnalazione"}
                                title={"Attenzione!"}
                                textButtonOk={"Sì"}
                                textButtonKo={"Torna indietro"}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                confirmFun={this.archiviaSegnalazione}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                    <div>
                        {!this.state.formModificato ? (
                            <Button
                                className={`btnWhite  ${styles.button}`}
                                id={"esciSenzaSalvare"}
                                text={"Esci senza salvare"}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                onClick={this.tornaAllaHome}
                            />
                        ) : (
                            <Modale
                                classes={`btnWhite ${styles.button}`}
                                id={"esciSenzaSalvare"}
                                typeModal="modalConsenso"
                                modalText={
                                    "Uscendo i dati inseriti saranno persi, confermi?"
                                }
                                text={"Esci senza salvare"}
                                title={"Esci"}
                                textButtonOk={"Esci"}
                                textButtonKo={"Indietro"}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                confirmFun={this.tornaAllaHome}
                            />
                        )}
                    </div>
                    <div>
                        <Modale
                            classes={`btnWhite ${styles.button}`}
                            id={"pulisciCampi"}
                            typeModal="modalConsenso"
                            modalText={getResetModalText("modalText")}
                            resetShowModale={this.resetShowModale}
                            attivazioneImmediata={this.state.showResetModal}
                            text={getResetModalText("title")}
                            title={getResetModalText("title")}
                            textButtonOk={getResetModalText("buttonText")}
                            textButtonKo={"Indietro"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            confirmFun={
                                this.state.modeResetModal === "changePage"
                                    ? this.navigateAway
                                    : this.pulisciCampi
                            }
                            disabled={
                                !this.state.formModificato &&
                                !isModificaSegnalazione
                            }
                            backgroundAction={this.resetShowModale}
                        />
                    </div>
                    <div>
                        <Button
                            id={
                                isModificaSegnalazione
                                    ? "modificaSegnalazione"
                                    : "inserisciSegnalazione"
                            }
                            className={`btnBlu  ${styles.button}`}
                            text={`${
                                isModificaSegnalazione
                                    ? "Modifica"
                                    : "Inserisci"
                            } segnalazione`}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            onClick={this.submitSegnalazione}
                            disabled={
                                this.state.codicePaziente.valoreCodice === ""
                            }
                        />
                        <Modale
                            classes={`${styles.button}`}
                            soloModale={true}
                            id={
                                isModificaSegnalazione
                                    ? "modificaSegnalazioneCodicePaziente"
                                    : "inserisciSegnalazioneCodicePaziente"
                            }
                            typeModal="modalOscura"
                            modalText={this.state.testoModale}
                            title={"Attenzione!"}
                            textButtonOk={"Sì"}
                            textButtonKo={"Modifica il codice"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            confirmFun={() =>
                                isModificaSegnalazione
                                    ? this.putSegnalazioneCompleta(
                                          this.state.datiAnagrafica.id
                                      )
                                    : this.postSegnalazioneCompleta()
                            }
                        />
                        <Modale
                            classes={`btnBlu ${styles.button}`}
                            buttonMail={true}
                            soloModale={true}
                            id={
                                isModificaSegnalazione
                                    ? "modificaSegnalazioneOk"
                                    : "inserisciSegnalazioneOk"
                            }
                            typeModal="modalConsenso"
                            modalText={`Segnalazione ${
                                isModificaSegnalazione
                                    ? "modificata"
                                    : "inserita"
                            } correttamente!`}
                            title={`${
                                isModificaSegnalazione
                                    ? "Modifica"
                                    : "Inserimento"
                            } segnalazione`}
                            textButtonOk={"Torna alla home"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            confirmFun={this.tornaAllaHome}
                            backgroundAction={this.tornaAllaHome}
                        />
                        <Modale
                            classes={`btnBlu ${styles.button}`}
                            buttonMail={true}
                            soloModale={true}
                            id={"eliminaSegnalazioneOk"}
                            typeModal="modalConsenso"
                            modalText={"Segnalazione eliminata correttamente!"}
                            title={"Eliminazione segnalazione"}
                            textButtonOk={"Torna alla home"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            confirmFun={this.tornaAllaHome}
                            backgroundAction={this.tornaAllaHome}
                        />
                    </div>
                </div>
                {ToasterSingleton.instance().renderToaster()}
            </div>
        );
    }
}

export default FormHIV;
